<template>
  <div
    :class="[`wishlist-icon wishlist-icon--${colour}`, (brandName === Brand.Travelsphere ? 'wishlist-iconTs' : ''), (wishlistState ? 'wishlist-icon--added' : '')]"
    @click="wishlistState = !wishlistState"
  ></div>
</template>

<script>
import Cookies from 'js-cookie';
import {Brand} from '../../../brand.js';

export default {
  name: 'WishlistToggle',
  props: {
    inWishlist: Boolean,
    wishlistCookieName: String,
    tourCode: String,
    tourName: String,
    tourCurrency: String,
    tourPrice: String,
    brandName: String,
    colour: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      wishlistState: this.inWishlist || false,
      Brand
    };
  },
  watch: {
    wishlistState() {
        // get wishlist cookie
      let wishlist = Cookies.getJSON(this.wishlistCookieName) || [];

      // get index of item in cookie
      const cookieIndex = wishlist.indexOf(this.tourCode);

      // add/remove item from cookie
      if (this.wishlistState && cookieIndex === -1) {
        wishlist.push(this.tourCode);
        
        var dataLayerItem = JSON.parse(JSON.stringify({
          currency: this.tourCurrency,
          value: Number(this.tourPrice),
          items: [{
            item_id: this.tourCode,
            item_name: this.tourName
          }]
        }));
        GTM.event('add_to_wishlist', dataLayerItem);
      } else if (!this.wishlistState && cookieIndex > -1) {
        wishlist = wishlist
          .slice(0, cookieIndex)
          .concat(wishlist.slice(cookieIndex + 1, wishlist.length));
      }

      if(wishlist.length > 0) {
        // set the cookie
        Cookies.set(this.wishlistCookieName, wishlist);
      } else {
        Cookies.remove(this.wishlistCookieName);
      }
    }
  }
};
</script>